import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { SITE_LAYOUT } from 'tradera/constants/ui';
import { BREAKPOINT_SIZES } from 'tradera/constants/breakpoints';

/**
 * Count the number of system messages that should cause alerts and badges
 *
 * @param {object} systemMessages
 * @returns {number}
 */
export const getSystemMessageAlertCount = (systemMessages = {}) => {
    return (
        (systemMessages.InvoiceOverdue ? 1 : 0) +
        (systemMessages.PayoutFailed ? 1 : 0) +
        (systemMessages.PayoutReadyBankAccountMissing ? 1 : 0) +
        (systemMessages.HyperwalletPayeeVerificationRequired ? 1 : 0) +
        (systemMessages.KycQuestionnaire ? 1 : 0) +
        (systemMessages.PayoutReadyVerificationRequired ? 1 : 0) +
        (systemMessages.PayoutReadyOutstandingTraderaPayLicense ? 1 : 0) +
        (systemMessages.UnreadPayouts ? 1 : 0)
    );
};

export const useIsSiteWidthFull = () => {
    const isExtraLargeDesktop = useMediaQuery({
        minWidth: BREAKPOINT_SIZES.XL.min
    });
    const siteLayout = useSelector((state) => state.ui.siteLayout);
    return siteLayout === SITE_LAYOUT.FULL_WIDTH && isExtraLargeDesktop;
};
